module.exports = __webpack_public_path__ + "static/img/ABUIABAEGAAgs_KFmQYoiOGlvwcwuAg4hAI.e8ed310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ABUIABAEGAAgs_KFmQYoiOGlvwcwuAg4hAI.png
// module id = M8n+
// module chunks = 1